import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import ThemeConsumer from '@userzoomlibraries/toolkit-theme-manager/theme-consumer';
import isString from '@userzoomlibraries/toolkit-js-utils/is-string';
import useAriaAttributes from '@userzoomlibraries/toolkit-react-utils/use-aria-attributes';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { jsx } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var SVG = styled.svg.attrs({
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  role: 'img'
}).withConfig({
  componentId: "gz-icon-1679041966581__sc-zs9gnu-0"
})([""]);

var _excluded = ["id", "className", "name", "fallback"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Icon$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      className = _ref.className,
      name = _ref.name,
      fallback = _ref.fallback,
      rest = _objectWithoutProperties(_ref, _excluded);

  var ariaAttributes = useAriaAttributes(rest);
  var dataAttributes = useDataAttributes(rest);
  return /*#__PURE__*/jsx(ThemeConsumer, {
    children: function children(theme) {
      var iconsByTheme = theme ? theme.icons : {};
      var iconName;
      var iconToRender;
      var principalIcon = iconsByTheme[name];

      if (principalIcon) {
        var path = principalIcon.path,
            _principalIcon$viewBo = principalIcon.viewBox,
            viewBox = _principalIcon$viewBo === void 0 ? '0 0 24 24' : _principalIcon$viewBo;
        iconToRender = path && /*#__PURE__*/jsx(SVG, {
          viewBox: viewBox,
          children: path
        });
        iconName = name;
      } else if (fallback) {
        if (isString(fallback)) {
          var fallbackIcon = iconsByTheme[fallback];

          if (fallbackIcon) {
            var _path = fallbackIcon.path,
                _fallbackIcon$viewBox = fallbackIcon.viewBox,
                _viewBox = _fallbackIcon$viewBox === void 0 ? '0 0 24 24' : _fallbackIcon$viewBox;

            iconToRender = _path && /*#__PURE__*/jsx(SVG, {
              viewBox: _viewBox,
              children: _path
            });
            iconName = fallback;
          }
        } else {
          iconToRender = fallback;
          iconName = 'custom-svg';
        }
      }

      return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread(_objectSpread({
        id: id,
        ref: ref,
        className: "gz-icon gz-icon-".concat(iconName, " ").concat(className) // eslint-disable-next-line react/jsx-props-no-spreading

      }, ariaAttributes), dataAttributes), {}, {
        children: iconToRender
      }));
    }
  });
});
Icon$1.COMPONENT_ID = 'Gearz.Icon';
Icon$1.displayName = Icon$1.COMPONENT_ID;
Icon$1.propTypes = {
  id: PropTypes.stringWithDescription('Id of the icon.'),
  name: PropTypes.stringWithDescription('Name of the icon to load.'),
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  fallback: PropTypes.oneOfTypeWithDescription([PropTypes.string, PropTypes.node], 'Fallback icon to load in case of the `name` provided not found. It could receive a custom element to show.')
};
Icon$1.defaultProps = {
  id: null,
  name: null,
  className: '',
  fallback: null
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Icon = styled(Icon$1).withConfig({
  componentId: "gz-icon-1679041966581__sc-ztuvtn-0"
})(["display:inline-flex;height:16px;width:16px;svg{height:100%;width:100%;}", ""], function (props) {
  return getThemeByProps({
    componentId: Icon$1.COMPONENT_ID,
    props: props
  });
});
Icon.displayName = Icon$1.displayName;
Icon.propTypes = Icon$1.propTypes;
Icon.defaultProps = Icon$1.defaultProps;

export { Icon as I };
